(function () {
    'use strict';

    angular
        .module('app')
        .controller('contactController', contactController);

    contactController.$inject = ['$scope', 'contactService', '$http'];
    function contactController($scope, contactService, $http) {

        
        $scope.sendConfirmation = {};
        $scope.sendConfirmation.headline = null;
        $scope.sendConfirmation.successMessage = null;
        $scope.sendConfirmation.errorMessage = null;


        $scope.update = function(contactModel) {
            if (!$scope.sendcontactrequest.email.$valid) {
                $scope.showEmailError = true;
                return;
            }
            if (!$scope.sendcontactrequest.name.$valid) {
                $scope.showNameError = true;
                return;
            }
            if (!$scope.sendcontactrequest.org.$valid) {
                $scope.showOrgError = true;
                return;
            }

            $scope.sendContactRequest(contactModel).then(
                function(result) {
                    $scope.sendConfirmation.headline = result.data.headline;
                    $scope.sendConfirmation.successMessage = result.data.successMessage;
                    $scope.sendConfirmation.errorMessage = result.data.errorMessage;
                },
                function(reason) {
                },
                function(error) {
                    $scope.sendConfirmation.errorMessage = result.data.errorMessage;
                    Console.log(error);
                }
            );
        };
        $scope.reset = function () {
            $scope.user = angular.copy($scope.master);
        };
        $scope.reset();

        $scope.sendContactRequest = function(contactModel) {
            return $http.post('/api/contactrequest/send', JSON.stringify(contactModel), { cache: false });
        };


        //function sendContactRequest(take, skip) {
        //    if (vm.totalVideos > vm.skip) {

        //        videoService.getVideoData(take, skip).then(
        //            function (result) {
        //                for (var i = 0; i < result.data.videos.length; i++) {
        //                    vm.videoModel.videos.push(result.data.videos[i]);
        //                }

        //                vm.page = vm.page + 1;
        //                vm.skip = skip * vm.page;
        //                vm.loadedVideos = vm.skip;
        //                vm.showMore = result.data.showMore;
        //                vm.disableInfinteScroll = !vm.showMore;
        //            },
        //            function (reason) {
        //            },
        //            function (error) {
        //                Console.log(error);
        //            }
        //        );
        //    } else {
        //        vm.showMore = false;
        //    }
        //}
        //function getVideomodel(take, skip) {
        //    videoService.getVideoData(take, skip).then(
        //            function (result) {
        //                console.log(result.data);
        //                vm.videoModel = result.data;
        //                vm.totalVideos = result.data.totalCount;

        //                vm.showMore = result.data.showMore;
        //                vm.disableInfinteScroll = !vm.showMore;
        //                vm.loadedVideos = vm.skip;
        //                vm.page = 1;

        //            },
        //            function (reason) {
        //            },
        //            function (error) {
        //                Console.log(error);
        //            }
        //        );
        //}

        //function activate() {
        //    getVideomodel(3, 0);
        //}
        //activate();

    }
})();